<template>
  <default-view>
    <span slot="header">Calibration</span>
    <template slot="content" id="calibration-content">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h1>Calibration</h1>
          </v-col>
        </v-row>
      </v-container>

    </template>
  </default-view>

</template>

<script>

	import {
		VContainer, VLayout, VRow, VCol,
	} from 'vuetify'

	import DefaultView from './app/DefaultView'

	export default {
		name: "CalibrationView",
		components: {
			VContainer, VLayout, VRow, VCol,
			DefaultView,
		}
	}
</script>

<style scoped>

</style>